import { FractalSDKContext } from "../../context/fractal-sdk-context.js";
import { maybeGetAccessToken, maybeGetBaseUser } from "../../core/token.js";
import { useSignOut } from "./use-sign-out.js";
import { useSignIn } from "../use-sign-in.js";
import { useUserSetter } from "../use-user-setter.js";
import { useCallback, useContext, useEffect, useState } from 'react';
export const useAuthButtonProps = ({ onError, onSignOut, onSuccess, scopes, } = {}) => {
    const [fetchingUser, setFetchingUser] = useState(false);
    const [isAuthenticating, setIsAuthenticating] = useState(false);
    const { clientId, user } = useContext(FractalSDKContext);
    const { fetchAndSetUser } = useUserSetter();
    const { signOut } = useSignOut();
    const doError = useCallback((e) => {
        if (!onError) {
            return;
        }
        onError(e);
    }, [onError]);
    const doSuccess = useCallback((user) => {
        setIsAuthenticating(false);
        if (!onSuccess) {
            return;
        }
        onSuccess(user);
    }, [onSuccess]);
    const { signIn } = useSignIn({
        clientId,
        onSignIn: doSuccess,
        onSignInFailed: doError,
        scopes,
    });
    useEffect(() => {
        const baseUserFromLS = maybeGetBaseUser();
        const accessTokenFromLS = maybeGetAccessToken();
        const isAlreadyLoggedIn = Boolean(user);
        if (isAlreadyLoggedIn ||
            !baseUserFromLS ||
            !accessTokenFromLS ||
            fetchingUser) {
            return;
        }
        const refreshUser = async () => {
            setFetchingUser(true);
            await fetchAndSetUser(baseUserFromLS, accessTokenFromLS);
            setFetchingUser(false);
        };
        refreshUser();
    }, [user, fetchingUser, fetchAndSetUser]);
    const signedIn = Boolean(user);
    const onClick = useCallback(() => {
        if (signedIn) {
            signOut();
            onSignOut === null || onSignOut === void 0 ? void 0 : onSignOut();
        }
        else {
            setIsAuthenticating(true);
            signIn();
        }
    }, [signedIn, signOut, onSignOut, signIn]);
    return {
        loading: isAuthenticating,
        onClick,
        signedIn,
    };
};
//# sourceMappingURL=use-auth-button-props.js.map